module.exports = __webpack_public_path__ + "img/1290.da740851.gif";